var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 5,
    fill: "#0088CC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.38 10.1323L9.12065 18.3303C7.66979 18.9131 7.67818 19.7225 8.85446 20.0834L14.3126 21.786L26.9411 13.8183C27.5383 13.4549 28.0838 13.6504 27.6354 14.0485L17.4038 23.2825H17.4014L17.4038 23.2837L17.0273 28.9097C17.5788 28.9097 17.8223 28.6567 18.1316 28.3581L20.7827 25.7801L26.2972 29.8533C27.314 30.4133 28.0443 30.1255 28.2973 28.9121L31.9172 11.8518C32.2877 10.3662 31.3501 9.69349 30.38 10.1323Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/telegram_icon.c16f7b3b3ff3655f3f4d6a29c72ba1cb.svg";
export { ForwardRef as ReactComponent };